import React from 'react'
import PropTypes from 'prop-types'

import {
  Missions,
  Layout,
  SEO,
  Hero,
  AppStoreCTA,
  Stats,
  IO
} from '../components'

import { 
  Container,
  Box,
} from '@magicsoup.io/stock'

import { Section } from '../styled'

import { Link } from 'gatsby'

class IndexPage extends React.Component {
  render() {
    const { addScrollRef } = this.context
    
    return(
      <Layout>
        <Container maxWidth="100%" px={[0]}>
          <SEO title='Mission42' keywords={[`mission42`, `skills`, `learning`]} />
            <Hero />
            <Container px={[0]}>
              <Missions />
            </Container>
            <Section ref={node=> addScrollRef('appStoreCTA', node)}>
              <AppStoreCTA />
            </Section>
            <IO rootMargin="-50px">
              {({ isVisible }) => (
                <Stats isVisible={isVisible} />
              )}
            </IO>
        </Container>
      </Layout>
    )
  }
}

export default IndexPage

IndexPage.contextTypes = {
  addScrollRef: PropTypes.func.isRequired,
  scrollTo: PropTypes.func.isRequired,
}
